const introTabs = {
    mixins: [mixin_intro_tabs],
    data() {
        return {
            carouselitems: 1,
            slickOptions: {}
        }
    },
    mounted(){


        this.slickOptions = {
            edgeFriction: api.vars.slick.edgeFriction,
            infinite: false,
            arrows: true,
            prevArrow: api.vars.slick.prevArrow,
            nextArrow: api.vars.slick.nextArrow,
            dots: false,
            rows: 0,
            variableWidth: true ? jQuery('body').hasClass('p-article') : false,
            slidesToShow: this.carouselitems,
            responsive: [{
                breakpoint: api.vars.scr.desktop - 1,
                settings: {
                    variableWidth: true,
                    slidesToShow: 1
                }
            }]
        }
    }
}

let introTabsApp = [];
const introTabsDivs = document.querySelectorAll(".s-intro-tabs");
if (introTabsDivs.length) {
    for (let i = 0; i < introTabsDivs.length; ++i) {
        if (introTabsDivs[i].id && introTabsDivs[i].id !== "") {
            introTabsApp.push(Vue.createApp({...introTabs}));
            introTabsApp[i].directive('init', initDirective);
            introTabsApp[i].component("slick-carousel",slickCarousel);
            introTabsApp[i].mount(`#${introTabsDivs[i].id}`);
        }
    }
}